var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[(_vm.client === 'client1tenant')?_c('CWPageMedia'):_c('ExpoPageMedia')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }